import React from 'react'
import mediaVersionPropTypes from '@/shape/media-version'
import { arrayOf, shape, string, bool } from 'prop-types'
import Expander from '@/component/Primitive/Expander'

import MediaVersionContent from '../MediaVersions/component/MediaVersionContent'
import MediaVersionsNote from '@/component/Common/MediaVersionsNote'
import NetflixMediaVersionsNote from '../NetflixMediaVersionsNote'
import classNames from 'classnames'
import Type from '@/component/Primitive/Type'
import RatingColor from '../RatingColor'

import styles from './MediaVersionsEpisode.module.scss'
import ContentAdvice from '@/component/Primitive/ContentAdvice/ContentAdvice'
import formatDuration from './duration-formatter'

const MediaVersions = ({ details, distributor, showDuration, designV2 }) => (
  <div className={styles.MediaVersions}>
    {distributor === 'NETFLIX, INC' && <NetflixMediaVersionsNote />}
    {details.map((detail, i) => {
      const {
        classification,
        durationSeconds,
        episodeTitle,
        episode,
        title,
        visualAdviceLayer,
        shortFormInsight,
        nonDefiningIssues,
        synopsis
      } = detail

      const formattedDuration = formatDuration(durationSeconds)
      const episodeSubTitle = episode && `Episode: ${episode}`
      const subtitle = showDuration ? (
        <>
          {episodeSubTitle}
          <span className={styles.Duration}>{formattedDuration}</span>
        </>
      ) : (
        episodeSubTitle
      )

      return (
        <Expander
          key={`MediaVersion_${episodeTitle}_${durationSeconds}_${i}`}
          classification={classification}
          title={episodeTitle || title}
          subtitle={subtitle}
          className={classNames(
            styles.Expander,
            i % 2 !== 0 && styles.hasDarkerBackground
          )}
          classNames={{
            icon: styles.Icon,
            title: styles.Title,
            subtitle: styles.Subtitle
          }}
          options={{
            classificationFirst: true,
            spacious: true,
            titlesStacked: true,
            iconConfig: {
              open: 'plus',
              close: 'minus'
            }
          }}
        >
          {shortFormInsight && (
            <Type className={styles.SRISubtitle} size="subtitle">
              <RatingColor
                property="color"
                className={styles.Themes}
                rating={classification}
              >
                <span>{shortFormInsight}</span>
              </RatingColor>
            </Type>
          )}
          <MediaVersionContent
            designV2={designV2}
            details={detail}
            key={`MediaVersionRow-${i}`}
          />
          {visualAdviceLayer &&
            visualAdviceLayer.details &&
            visualAdviceLayer.details.length > 0 && (
              <Expander
                title="Content Advice"
                className={styles.RatingsExpander}
                classNames={{
                  title: styles.RatingsExpanderTitle,
                  icon: styles.RatingsExpanderIcon
                }}
              >
                {synopsis && (
                  <p className={styles.Synopsis}>{synopsis}</p>
                )}
                {visualAdviceLayer && (
                  <ContentAdvice
                    showDescription
                    data={visualAdviceLayer.details}
                    showOnMobile
                    hideDots
                    primaryAssetNonDefiningIssues={nonDefiningIssues}
                  />
                )}
              </Expander>
            )}
        </Expander>
      )
    })}
    <MediaVersionsNote />
  </div>
)

MediaVersions.propTypes = {
  details: arrayOf(shape(mediaVersionPropTypes)),
  distributor: string,
  showDuration: bool,
  designV2: bool
}

export default MediaVersions
